/* eslint-disable import/prefer-default-export */
import StringUtil from '@leverege/string-util';
function prefixVariant(variant, prefix, dVal) {
  if (!variant) {
    return null;
  }
  if (!prefix && !dVal) {
    return variant;
  }
  return `${prefix ? `${prefix.charAt(0).toLowerCase()}${prefix.slice(1)}${StringUtil.capitalize(variant)}|` : ''}${variant}${dVal ? `|${dVal}` : ''}`;
}
export { prefixVariant };